import Vue from 'vue'
import deviceUtils from './deviceUtils'

const authorizationUtils = {
  /* 用户认证 */
  toAuthorize: function (router) {
    let redirect = router.currentRoute.fullPath
    if (localStorage.getItem('loginSource') === 'union') {
      const loginType = localStorage.getItem('unionLoginType')
      const target = loginType ? '/unionLogin?type=' + loginType : '/unionLogin'
      router.replace(target)
    } else if (redirect.indexOf('/studentspace/degree') === 0) {
      router.replace('/studentspace/homepage?redirect=' + decodeURIComponent(redirect))
    } else if (redirect.indexOf('/studentResults/query') === 0) {
      router.replace('/studentResults/homepage?redirect=' + decodeURIComponent(redirect))
    } else if (redirect.indexOf('/registerstudentpay/degree') === 0) {
      router.replace('/registerstudentpay/homepage?redirect=' + decodeURIComponent(redirect))
    } else if (redirect.indexOf('/studentUnion') === 0) {
      router.replace('/unionLogin?redirect=' + decodeURIComponent(redirect))
    } else {
      router.replace('/authorize?redirect=' + decodeURIComponent(redirect))
      Vue.nextTick(() => this.toWeChatAuth(redirect))
    }
  },
  /* 微信授权 */
  toWeChatAuth: function (redirect) {
    if (deviceUtils.isWeChatBrowser()) {
      Vue.prototype.$ajax({
        url: '/index/m/ws/auth',
        method: 'post',
        data: Vue.prototype.$qs.stringify({
          redirect: decodeURIComponent(redirect || '')
        })
      }).then(response => {
        if (response.data) {
          let authorizeUrl = response.data['authorizeUrl']
          if (authorizeUrl) {
            window.location.href = authorizeUrl
          }
        }
      })
    }
  }
}

export default authorizationUtils
